import { render, staticRenderFns } from "./ImgSingleBlog.vue?vue&type=template&id=30845189&scoped=true"
import script from "./ImgSingleBlog.vue?vue&type=script&lang=js"
export * from "./ImgSingleBlog.vue?vue&type=script&lang=js"
import style0 from "./ImgSingleBlog.vue?vue&type=style&index=0&id=30845189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30845189",
  null
  
)

export default component.exports